import type { ClassSlotRow } from '@repo/shared-types';

export interface SlotTimeGroup {
  time: string;
  days: number[];
}

/**
 * Groups a class's khung giờ by shared start time — "T3, T5 18:00 · T7
 * 08:00" reads as two groups, not three separate chips. Extracted from
 * `ClassListTab`'s own `groupSlotsByTime` (THI-267 Task 10) so the student
 * page's per-class schedule line (Task 14) and the Xếp lớp dialog's class
 * cards read the exact same grouping instead of a second, drifting copy.
 *
 * Ordered by first weekday, then time, so the result always reads
 * Monday-first regardless of the API's own slot order.
 */
export function groupSlotsByTime(slots: ClassSlotRow[]): SlotTimeGroup[] {
  const byTime = new Map<string, number[]>();
  for (const s of slots) {
    const days = byTime.get(s.startTime) ?? [];
    days.push(s.dayOfWeek);
    byTime.set(s.startTime, days);
  }
  return [...byTime.entries()]
    .map(([time, days]) => ({ time, days: [...new Set(days)].sort((a, b) => a - b) }))
    .sort((a, b) => (a.days[0] ?? 0) - (b.days[0] ?? 0) || a.time.localeCompare(b.time));
}
